
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/terms-of-use",
      function () {
        return require("private-next-pages/legal/terms-of-use.js");
      }
    ]);
  